import { Controller } from "@hotwired/stimulus";
import { dispatchFilterUpdatedEvent } from "../../datatables/datatable_filters";

export default class extends Controller {
  static targets = ["selectInput"];
  static outlets = ["datatables--selected-filter"];

  connect() {
    if (this.hasDatatablesSelectedFilterOutlet) {
      // This is needed to ensure that the select2 input is initialized before displaying the selected filter
      setTimeout(() => {
        this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
      }, 0);
    }
  }

  filterChanged() {
    this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    this._filterUpdated();
  }

  _filterUpdated() {
    const { filterName } = this.element.dataset;
    dispatchFilterUpdatedEvent({ name: filterName });
  }

  _translatedValue() {
    const selectedData = $(this.selectInputTarget).select2("data");
    return selectedData.map((data) => data.text).join(", ");
  }
}
